<template>
   <div class="container">
                <div class="page-header">
                    <div class="page-title">
                        <h3> <i class="flaticon-computer-6 " style="color:#1a73e9"></i> لوحة التحكم  </h3>
                    </div>
                </div>
    <admin-dashboard v-if="user.role == 'admin'" />
    <parent-dashboard v-if="user.role == 'parent'" />
    <teacher-dashboard v-if="user.role == 'teacher'" />
  </div>
</template>
<script>
import Vue from "vue";
import baseApi from '@/baseApi'
import AdminDashboard from '../components/Dashboard/Admin.vue'
import ParentDashboard from '../components/Dashboard/Parent.vue'
import TeacherDashboard from '../components/Dashboard/Teacher.vue'
export default {
  components: {
    AdminDashboard,
    ParentDashboard,
    TeacherDashboard
  },
  data() {
    return {
      data: {
        students: 0,
        saveReviews: 0,
        groups: 0,
        lessons: 0,
        childs: 0,
        accpt: 0,
        errors: {},
        isRequested: false,
        form: {
          capacity: ''
        }
      },
      statsCards: [
      ],
      activityChart: {
        data: {
          labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          axisX: {
            showGrid: false
          },
          height: "500px"
        }
      },
    }
  },
  created() {
  
  },
  methods: {
    getTransKey(k) {
      return this.trans.dashboard ? this.trans.dashboard.databy[k] : k;
    },
    sendStatsRequest(mod) {
      baseApi().get('/counter?q=' + mod).then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
          this.statsCards.push(response.data.data);
        } else if (response.data.code === 404) {
        } else {
          alert(response.data.error);
        }
      });
    },
    modDetails() {
      return ['users', 'managemnt', 'passports'];
    },
    handleModules(mod, data) {
    },
    getStates() {
      baseApi().get('/home').then((response) => {
        if (response.data.code === 200) {
          if(this.user.role != 'parent'){
            this.data.students    = response.data.data.studentCount;
            this.data.saveReviews = response.data.data.saveReviewCount;
            this.data.lessons     = response.data.data.lessonCount;
            this.data.groups      = response.data.data.groupCount;
          }else{
            this.data.childs      = response.data.data.requests;
            this.data.accpt       = response.data.data.studentChild;
          }
          
        }
      });
    },
  },
  computed: {
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
.ct-bar {
  stroke-width: 17px !important;
}
.card .ct-chart {
  height: auto !important;
}
.card .footer div {
  width: 100%;
  text-align: center;
}
</style>
